/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The type of event. 'one_off' for single events that occur once, 'recurring' for events that are part of a recurring series with multiple occurrences
 */
export type ListEventSeriesResponseDataItemEventType =
  (typeof ListEventSeriesResponseDataItemEventType)[keyof typeof ListEventSeriesResponseDataItemEventType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListEventSeriesResponseDataItemEventType = {
  one_off: "one_off",
  recurring: "recurring"
} as const
